import { FileBadge, Truck, FlaskConical } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const SERVICES = [
  { icon: FileBadge, title: "Licensed Purchasing", text: "Purchase through properly licensed channels, coordinated by our team.", color: "text-purple-400" },
  { icon: Truck, title: "Guaranteed Shipping", text: "Reliable, guaranteed delivery of your product to where you need it.", color: "text-orange-400" },
  { icon: FlaskConical, title: "Independent Lab Testing Assistance", text: "We connect you with an independent lab and help you submit samples for your own COA.", color: "text-emerald-400" },
];

export const AddOns = () => (
  <section className="pb-24 sm:pb-32" data-testid="addons-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] bg-[#0A170F] text-white p-8 sm:p-14 grid gap-10 lg:grid-cols-12">
          <img src="/images/abstract.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
          <div className="relative lg:col-span-5">
            <p className="eyebrow text-amber-300">Add-on services</p>
            <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight">Need more than an intro?</h2>
            <p className="mt-4 text-white/75 leading-relaxed">
              Available at extra cost and quoted separately. Add-on services are <span className="font-bold text-white">not included</span> in membership pricing.
            </p>
          </div>
          <div className="relative lg:col-span-7 grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
            {SERVICES.map((s) => (
              <div key={s.title} className="rounded-2xl bg-white/10 backdrop-blur-xl border border-white/15 p-6 hover:bg-white/15 transition-colors" data-testid={`addon-card-${s.title.toLowerCase().replace(/\s/g, "-")}`}>
                <s.icon className={`h-8 w-8 ${s.color}`} />
                <h3 className="mt-4 text-xl font-bold">{s.title}</h3>
                <p className="mt-2 text-white/70 text-sm">{s.text}</p>
                <p className="mt-4 text-xs font-bold uppercase tracking-widest text-amber-300">Quoted separately</p>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
